import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import "./i18nextConf";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import { DiscoverProvider } from "./apps/Discover/DiscoverContext";
import { ProfileProvider } from "./apps/Profile/contexts/ProfileContext";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ProfileProvider>
          <DiscoverProvider>
            <App />
          </DiscoverProvider>
        </ProfileProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
